// Module
var code = "<abx-range-input abx-label=\"{{ ::pinField.name }}\" abx-type=\"{{ ::pinField.data_type }}\" abx-on-blur=\"vm.handleFilterChange($event, pinField)\" abx-model=\"vm.currentFilters[pinField._id]\" abx-blur-on-enter=\"true\" abx-disabled=\"vm.disabled\"> </abx-range-input> ";
// Exports
module.exports = code;